import React from 'react';
import { string, oneOf, oneOfType, node } from 'prop-types';

import './Chip.scss';

const Chip = ({ text = '', type = 'success' }) =>
  <div className={`Chip--${type}`}>
    <p className="Chip__text">{text}</p>
  </div>

Chip.propTypes = {
  text: oneOfType([string, node]),
  type: oneOf(['success', 'warn', 'danger', 'info', 'disabled', 'neutral']),
};

export default Chip;
